export interface AirChfarExerciseDiscountContext {
  chfarId?: string;
}

export const AirChfarExerciseDiscountInitialContext = {
  chfarId: undefined,
};
